export class EngagementLinkRequest {
    GAValue:string;
    engagementID:number;
}
